<!-- <p>annual-reports works!</p> -->
<div class="clear"></div>
<section class="banner">
	<div class="container py-4 d-flex justify-content-between align-items-center">
		<h1 class="mb-0">Public Annual Reports </h1>
		<div class="input-group" style="max-width:300px;">
			<!-- <input type="text" class="form-control" [(ngModel)]="searchTerm" id="search" placeholder="search..."> -->
			<div class="input-group-append" id="button-addon4">
				<!-- <button class="btn btn-outline-secondary" type="button" (click)="ClearSearch()"><em class="fas fa-backspace fa-fw"></em></button> -->
			</div>
		</div>
	</div>
</section>
<div class="clear py-3"></div>
<section class="container">

<h6 class="well font-weight-medium">
    <a href="./assets/docs/Anuual_Reports/ar2020-21.pdf" target="_blank" class="d-flex w-100 justify-content-between">
        <span>   					
            <i class="far fa-hand-point-right text-primary mr-2"></i>
            <ngx-highlight-words
                [textToHighlight]="' PPRA Annual Report, 2020-21 '"
     
                highlightClassName="bg-Searchable">
            </ngx-highlight-words>
        </span>
    </a>
</h6>

<h6 class="well font-weight-medium">
    <a href="./assets/docs/Anuual_Reports/ar2013-20.pdf" target="_blank" class="d-flex w-100 justify-content-between">
        <span><i class="far fa-hand-point-right text-primary mr-2"></i>
            <ngx-highlight-words
            [textToHighlight]="' PPRA Annual Report, 2013-20'"
 
            highlightClassName="bg-Searchable">
            </ngx-highlight-words>
        </span>
    </a>
</h6>

<h6 class="well font-weight-medium">
    <a href="./assets/docs/Anuual_Reports/ar2012-13.pdf" target="_blank" class="d-flex w-100 justify-content-between">
        <span><i class="far fa-hand-point-right text-primary mr-2"></i>
            <ngx-highlight-words
            [textToHighlight]="' PPRA Annual Report, 2012-13'"
 
            highlightClassName="bg-Searchable">
            </ngx-highlight-words>
        </span>
    </a>
</h6>
<h6 class="well font-weight-medium">
    <a href="./assets/docs/Anuual_Reports/ar2008-12.pdf" target="_blank" class="d-flex w-100 justify-content-between">
        <span><i class="far fa-hand-point-right text-primary mr-2"></i>
            <ngx-highlight-words
            [textToHighlight]="' PPRA Annual Report, 2008-12.'"
 
            highlightClassName="bg-Searchable">
            </ngx-highlight-words>
        </span>
    </a>
</h6>
</section>